import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';

export default function DatePickerInicio({ inicio, setInicio, maxDate, label }: { inicio: number | Date | null, setInicio: Function, maxDate: number | Date | null, label: string }) {

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DesktopDatePicker
        format='dd/MM/yyyy'
        label={label}
        value={inicio ? new Date(inicio) : null}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        onChange={(newValue) => {
          if (!newValue) return setInicio(null);
          const date = new Date(newValue.getTime());
          date.setHours(0, 0, 0, 0);
          setInicio(date);
        }}
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          field: {
            readOnly: true,
          },
        }}
        localeText={{
          clearButtonLabel: 'Limpar',
        }}
      />
    </LocalizationProvider>
  );
}
